module.exports = __webpack_public_path__ + "img/HospitalPlaceHolder.3454c920.png";